import { optionTitle_notificationsInAppNotifications } from './AppNotificationsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let AppNotificationsOptions: LazyOption = createLazyOption(
    {
        key: 'appNotifications',
        titleStringKey: optionTitle_notificationsInAppNotifications,
        searchTermsStringKey: optionTitle_notificationsInAppNotifications,
    },
    lazyFullModule,
    m => m.default
);
export default AppNotificationsOptions;
